import { Box, Stack, Typography } from '@mui/material';
import * as React from 'react';
import * as JSTool from '../store/JSTool';
import $ from 'jquery';
import NavView from '../component/NavView';
import PageFooter from './PageFooter';
import SectionView from '../component/home/SectionView';
import AboutSectionView from '../component/home/AboutSectionView';
import { useSelector, useDispatch } from 'react-redux';
import { settingActions, settingObj } from '../store/SettingSlice';
import { getImgPath } from '../store/JSTool';

export default function AboutUsPage() {

    let navId = 'about_us_page_nav';
    let pageId = 'about_us_page_div';
    let sectionIdAry = ['about_about', 'about_who', 'about_affiliation'];
    const settingData = useSelector(state => state.settingData);


    React.useEffect(() => {
        JSTool.addPageScrollListener(pageId, navId, 0, sectionIdAry);
    }, []);

    return (
        <Stack component={'div'}
            sx={{
                width: 1,
                height: '100vh',
                position: 'relative',
            }}>
            <NavView navId={navId} pageId={pageId} />

            <Stack
                id={pageId}
                component={'div'}
                sx={{
                    width: 1,
                    overflow: 'auto',
                    position: 'relative',
                    alignItems: 'center',
                    minHeight: '100vh',
                }} >

                <Stack sx={{
                    width: 1,
                    bgcolor: 'black'
                }}>
                    <Box
                        component={'img'}
                        src={getImgPath('apj_banner.png')}
                        sx={{
                            opacity: 0.5,
                            width: 1,
                            maxHeight: '300px',
                            minHeight: '150px',
                            objectFit: 'cover',
                        }} />
                </Stack>

                <SectionView id={sectionIdAry[0]} title='About' />
                <AboutSectionView />
                <SectionView id={sectionIdAry[1]} title='Who We Are' />

                <Typography sx={{
                    fontSize: 37,
                    fontFamily: settingData.fontFM,
                }}>
                   {settingData.langDic['lang16']}
                </Typography>

                <Stack sx={{
                    width: '1200px',
                    alignItems: 'center',
                    flexDirection: 'row',
                    justifyContent: 'center',
                }}>
                    <Box component={'img'}
                        src={getImgPath('jp_company.jpg')}
                        sx={{
                            width: 0.4,
                            borderRadius: '10px',
                            ml: 10,
                        }} />

                    <Stack sx={{
                        width: 0.42,
                        ml: 5,
                    }}>
                        <AddressItem title={settingData.langDic['lang17']} detail={settingData.langDic['lang18']} />
                        <AddressItem title={settingData.langDic['lang19']} detail={settingData.langDic['lang20']} />
                        <AddressItem title={settingData.langDic['lang21']} detail={settingData.langDic['lang22']} />
                        <AddressItem title={settingData.langDic['lang23']} detail={settingData.langDic['lang24']} />
                        <AddressItem title={settingData.langDic['lang25']} detail={settingData.langDic['lang26']} />
                    </Stack>
                </Stack>

                <AddressMap />

                <SectionView id={sectionIdAry[2]} title='Affiliations' />
                <Stack sx={{
                    flexDirection: 'row',
                    mt: 3,
                }}>
                    <LogoItem index={0} detail="Japan Online Game Association" imgName='joga3.png' />
                    <LogoItem index={1} detail="Computer Entertainment Supplier's Association" imgName='cesa2.png' />
                </Stack>

                <Box sx={{ flex: 1, mt: 3 }} />
                <PageFooter pageId={pageId} />
            </Stack>
        </Stack>
    );
}

function LogoItem(props) {

    function tap() {
        if (props.index == 0) {
            window.open("https://japanonlinegame.org");
        } else if (props.index == 1) {
            window.open("https://www.cesa.or.jp/index.html");
        }
    }

    return (
        <Stack
            onClick={tap}
            sx={{
                justifyContent: 'center',
                alignItems: 'center',
                mt: 1,
                mb: 6,
                cursor: 'pointer',
                mx: 5,
            }}>

            <Box
                component={'img'}
                src={getImgPath(props.imgName)}
                sx={{
                    height: '55px'
                }} />

            <Typography sx={{
                fontSize: 17,
                fontFamily: 'Source Han Sans CN',
                mt: 1.5,
            }}>
                ({props.detail})
            </Typography>

        </Stack>
    );
}


function AddressItem(props) {
    const settingData = useSelector(state => state.settingData);

    function tap() {
        if ("Address" == props.title) {
            window.open("https://www.google.com/maps/place/%E8%99%8E%E4%B9%8B%E9%97%A8%E4%B9%8B%E4%B8%98/@35.6668481,139.7485207,19z/data=!4m6!3m5!1s0x60188b93a18a3a03:0x53be098c7d98c19b!8m2!3d35.6668271!4d139.7491539!16s%2Fm%2F0wf9mq4?entry=ttu");
        }
    }

    return (
        <Stack
            onClick={tap}
            sx={{
                flexDirection: 'row',
                mt: 4,
                cursor: ("Address" == props.title && 'pointer')
            }}>
            <Typography sx={{
                width: '135px',
                minWidth: '135px',
                bgcolor: 'black',
                color: 'white',
                textAlign: 'center',
                height: '35px',
                lineHeight: '35px',
                borderRadius: '5px',
                fontFamily: settingData.fontFM,
            }}>
                {props.title}
            </Typography>

            <Typography sx={{
                fontFamily: settingData.fontFM,
                ml: 2,
                mt: 0.5,
                fontSize: 17,
            }}>
                {props.detail}
            </Typography>

        </Stack>
    );
}

function AddressMap(props) {
    const settingData = useSelector(state => state.settingData);

    return (
        <Stack sx={{
            width: '1200px',
            position: 'relative',
            mb: 5,
        }}>

            <Box component={'img'}
                src={getImgPath('map.png')}
                sx={{
                    width: '650px',
                    minWidth: '650px',
                }} />

            <MapPoint title='TOKYO' top={185} left={590} lineHeight={35} />
            <MapPoint title='SHANGHAI' top={255} left={455} lineHeight={95} />
            <MapPoint title='SINGAPORE' top={514} left={280} lineHeight={40} isUp={true} />

            <MapInfo index={0} top={200} lineWidth={82} title={settingData.langDic['lang16']} detail={settingData.langDic['lang26']} />
            <MapInfo index={1} top={330} lineWidth={202} title={settingData.langDic['lang27']} detail={settingData.langDic['lang28']} />
            <MapInfo index={2} top={460} lineWidth={372} title='A PLUS ENTERTAINMENT PTE. LTD.' detail='12 Woodlands Square #10-73 Woods Square, Singapore' />

        </Stack>
    );
}

function MapPoint(props) {
    return (
        <Stack sx={{
            position: 'absolute',
            alignItems: 'center',
            zIndex: 2,
            top: `${props.top}px`,
            left: `${props.left}px`,
            flexDirection: props.isUp ? 'column-reverse' : 'column'
        }}>
            <Typography sx={{
                fontWeight: 'bold'
            }}>
                {props.title}
            </Typography>

            <Box
                sx={{
                    bgcolor: '#FFA028',
                    width: '10px',
                    height: '10px',
                    borderRadius: '5px',
                }} />

            <Box sx={{
                width: '1px',
                height: `${props.lineHeight}px`,
                bgcolor: 'black',
            }} />

        </Stack>
    );
}

function MapInfo(props) {

    const settingData = useSelector(state => state.settingData);

    function tap() {
        if (props.index == 0) {
            window.open("https://www.google.com/maps/place/%E8%99%8E%E4%B9%8B%E9%97%A8%E4%B9%8B%E4%B8%98/@35.6668481,139.7485207,19z/data=!4m6!3m5!1s0x60188b93a18a3a03:0x53be098c7d98c19b!8m2!3d35.6668271!4d139.7491539!16s%2Fm%2F0wf9mq4?entry=ttu");

        } else if (props.index == 1) {
            window.open("https://www.google.com/maps/place/%E5%85%AD%E5%85%AB%E5%85%AB%E5%B9%BF%E5%9C%BA/@31.2316007,121.4620626,17z/data=!4m6!3m5!1s0x35b270144600a3bd:0xdaaa2d264d0d8610!8m2!3d31.231408!4d121.464541!16s%2Fg%2F11cm1j6fw7?entry=ttu");

        } else if (props.index == 2) {
            window.open("https://www.google.com/maps/place/Woodlands+Square,+%E6%96%B0%E5%8A%A0%E5%9D%A1/@1.4383392,103.7643638,14z/data=!4m6!3m5!1s0x31da13a8888377d1:0xdd95aae21ea2565f!8m2!3d1.4364417!4d103.7849068!16s%2Fg%2F1td0qd7m?entry=ttu");
        }
    }

    return (
        <Stack
            onClick={tap}
            sx={{
                position: 'absolute',
                zIndex: 2,
                top: `${props.top}px`,
                left: '700px',
                cursor: 'pointer',
            }}>

            <Typography sx={{
                fontSize: 22,
                fontFamily: settingData.fontFM,
            }}>
                {props.title}
            </Typography>

            {/* 右边 */}
            <Stack sx={{
                flexDirection: 'row',
                mt: 1,
                width: '550px',
            }}>
                <Typography sx={{
                    width: '120px',
                    minWidth: '120px',
                    bgcolor: '#FFC714',
                    color: 'white',
                    textAlign: 'center',
                    height: '25px',
                    lineHeight: '25px',
                    borderRadius: '4px',
                    fontFamily: 'Lexend Deca',
                    fontSize: 13
                }}>
                    Location
                </Typography>


                <Typography sx={{
                    fontFamily: settingData.fontFM,
                    ml: 2,
                    fontSize: 13,
                }}>
                    {props.detail}
                </Typography>
            </Stack>

            <Box sx={{
                width: `${props.lineWidth}px`,
                height: '1px',
                bgcolor: 'black',
                position: 'absolute',
                top: '53px',
                left: `-${props.lineWidth}px`,
            }} />

        </Stack>
    );
}